import React, { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { PrivateRoute } from 'app/routes';

import { RecommendationNavbar } from 'features/navbar';
import { Flex } from 'components';
import Menu, { Menu2 } from 'features/menu';
import FullscreenProvider from 'features/fullscreen';
import { useSheets } from 'features/dashboard-new';
import { useSchool } from 'features/school';
import Footer from 'features/footer';
import { useBreakpoints } from 'app/hooks';

const RecommendationLayout = (): ReactElement => {
  const { usingDashboard } = useSheets();
  const { schoolAlias } = useSchool();
  const breakpoint = useBreakpoints();

  return (
    <PrivateRoute>
      <Flex className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`} flexWrap="inherit" minHeight="100vh" flexDirection="column">
        <FullscreenProvider display="flex" flexDirection="column">
          <Flex flexGrow={0}>
            {usingDashboard ? <Menu2 /> : <Menu />}
            <RecommendationNavbar />
          </Flex>

          <Flex as="main" flexWrap="nowrap" flexDirection="column">
            <Outlet />
          </Flex>
        </FullscreenProvider>

        <Flex flexGrow={0}>
          <Footer />
        </Flex>
      </Flex>
    </PrivateRoute>
  );
};

export default RecommendationLayout;
